<template>
    <div class="container">
        <h1>Đề xuất sản phẩm</h1>

        <b-button v-b-toggle.collapse-1 variant="">Điều kiện</b-button>
        <!-- <b-button v-b-toggle.collapse-2 variant="">Log</b-button> -->
        <b-collapse id="collapse-1" class="mt-2">
            <b-card>
                <div class="row">
                    <div class="col-6">
                        <b-spinner v-if="isLoadingClientInfo"></b-spinner>
                        <!-- <span>{{selectedMode}}</span> -->

                        <template v-for="rule in rules">
                            
                            <b-form-checkbox 
                                v-model="rule.selected" 
                                v-bind:key="rule.id" 
                                v-if="!isLoadingClientInfo">{{rule.label}}</b-form-checkbox>
                        </template>
                    </div>
                    
                    <div class="col-6">
                        <b-form-group label="" >
                            <b-form-radio v-model="selectedMode" name="some-radios" value="product">Sản phẩm ký gửi (mua)</b-form-radio>
                            <b-form-radio v-model="selectedMode" name="some-radios" value="product_rent">Sản phẩm ký gửi (thuê)</b-form-radio>
                            <b-form-radio v-model="selectedMode" name="some-radios" value="scan">Quét online</b-form-radio>
                            <b-form-radio v-model="selectedMode" name="some-radios" value="scan_rent">Quét online (thuê)</b-form-radio>
                        </b-form-group>
                    </div>
                </div>

                <b-button @click="suggestByAllRules" variant="primary">Đề xuất</b-button>
            </b-card>
        </b-collapse>

        

            <b-alert :show="message!=''">
                <p v-html="message"></p>
            </b-alert>
        <!-- </b-collapse> -->
        <hr/>

        <b-spinner v-if="isLoadingList"></b-spinner>
        <div v-if="!isLoadingList">
            <!-- <b-input v-model="filterString"></b-input> -->
            <b-table striped 
                sticky-header
                head-variant="light"
                :items="productList"
                :fields="tableFormat.fields"
                :sort-by.sync="tableFormat.sortBy"
                :sort-desc.sync="tableFormat.sortDesc"
                :currentPage="tableFormat.currentPage"
                perPage="10"
                sort-icon-left
                responsive="sm"
                >
                    <template #cell(date)="data">
                        {{formatDate(data.item.date)}}
                    </template>

                    <template #cell(street)="data">
                        <a href="#" @click="viewProduct(data.item.id)">{{data.item.street || "-"}} </a>
                    </template>

                    <template #cell(address)="data">
                        <a href="#" @click="viewProduct(data.item.id)">{{data.item.address || "-"}} </a>
                    </template>

                    <template #cell(matching)="data">
                        {{data.item.matchingLabel.join(",")}}
                    </template>
                </b-table>

            <b-pagination
                v-model="tableFormat.currentPage"
                :total-rows="tableFormat.totalRow"
                per-page="10"
                aria-controls="my-table"
                ></b-pagination>

            <span>Số lượng: {{tableFormat.totalRow}}</span>
        </div>
    </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'

import ClientService from '@/module-client/ClientService'
import ProductService from '@/services/productService'
import Constants from '@/constants'

import Firebase from '@/services/firebase'
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'ProductSuggestion',
  components: {

  },
  
  watch: {
      selectedMode: function (newVal, oldVal) {
        if(newVal === 'product') {
            this.rules = this.productRules;
        }
        else if(newVal === 'scan') { 
            this.rules = this.onlineRules;
        }
        else if(newVal === 'product_rent') { 
            this.rules = this.productRentRules;
        }
        else if(newVal === 'scan_rent') { 
            this.rules = this.onlineRentRules;
        }
    }
  },
  data () {
    return {
        tableFormat: {
            sortBy: 'street',
            sortDesc: false,
            fields: [
                { key: 'matching', label: 'Phù hợp với ĐK' },
                { key: 'date', label: 'Ngày tháng' },
                { key: 'fullname', label: 'Họ tên' },
                { key: 'street', label: 'Tên đường' },
                { key: 'address', label: 'Địa chỉ' },
                { key: 'trait', label: 'Đặc điểm' },
                { key: 'price', label: 'Giá'  },
                { key: 'priceForRent', label: 'Giá cho thuê'  },
                { key: 'area', label: 'Diện tích' },
                // { key: 'street', sortable: true },
                // { key: 'matchingWeight', label: 'Weight' }
            ],
            currentPage: 0,
            totalRow: 0
        },
        filterString: '',
        selectedMode: 'product', // product or scan
        rules: [],
        productRules: [],
        productRentRules: [],
        onlineRules: [],
        onlineRentRules: [],

        productMap: {},
        productList: [],
        clientInfo: {},
        message: '',
        
        isLoadingList: false,
        isLoadingClientInfo: false,
        clientService: null
    }
  },
  
  methods: {
      formatDate(v) {
          return moment(v).format('DD/MM/YYYY')
      },

      viewProduct(id) {
          if(this.selectedMode === 'product' || this.selectedMode === 'product_rent') {
              let routeData = this.$router.resolve({path: `/v2/products/${id}/view`, query: {  }});
            window.open(routeData.href, '_blank');
          }
          else {
              let routeData = this.$router.resolve({path: `/v2/online_scan/${id}/view`, query: {  }});
            window.open(routeData.href, '_blank');
          }
          
      },

        mapPriceRangeToSQLConditions(rangeString) {
            if(!rangeString || rangeString.length==0) {
                return '';
            }

            var tmp = rangeString.split(','); // assume that the range is like this: 700-1000,1000-1500,...

            var map = {
                'dưới 700 tr': 'price<700',
                '700-1000': 'price>=700 and price <= 1000',
                '1000-1500': 'price>=1000 and price <= 1500',
                '1500-2000': 'price>=1500 and price <= 2000',
                '2000-2600': 'price>=2000 and price <= 2600',
                '2600-3700': 'price>=2600 and price <= 3700',
                '3700-5000': 'price>=3700 and price <= 5000',
                'trên 5 tỷ': 'price>=5000',
                'Dưới 5tr': 'price < 5',
                '5tr - 10tr': 'price >= 5 and price < 10',
                '10tr - 30tr': 'price >= 10 and price < 30',
                'Trên 30tr': 'price >= 30'
            }

            var results = [];
            for(var i=0;i<tmp.length;i++) {
                var converted = map[tmp[i]];
                results.push(converted);
            }

            if(!results) return '';

            return results.join(' OR ');
        },

        mapPriceRentRangeToSQLConditions(rangeString) {
            if(!rangeString || rangeString.length==0) {
                return '';
            }

            var tmp = rangeString.split(','); // assume that the range is like this: 700-1000,1000-1500,...

            var map = {
                'Dưới 5tr': 'priceForRent < 5',
                '5tr - 10tr': 'priceForRent >= 5 and priceForRent < 10',
                '10tr - 30tr': 'priceForRent >= 10 and priceForRent < 30',
                'Trên 30tr': 'priceForRent >= 30',
            }

            var results = [];
            for(var i=0;i<tmp.length;i++) {
                var converted = map[tmp[i]];
                results.push(converted);
            }

            if(!results) return '';

            return results.join(' OR ');
        },

        mapAreaRangeToSQLConditions(rangeString) {
            if(!rangeString || rangeString.length==0) {
                return '';
            }

            var tmp = rangeString.split(','); // assume that the range is like this: 700-1000,1000-1500,...

            var map = {
                'dưới 45m2': 'area<45',
                '45-80m2': 'area>=45 AND area<=80',
                '80-100m2': 'area>=80 AND area<=100',
                '100-200m2': 'area>=100 AND area<=200',
                '200-1000m2': 'area>=200 AND area<=1000',
                'trên 1000m2': 'area>=1000'
            }

            var results = [];
            for(var i=0;i<tmp.length;i++) {
                var converted = map[tmp[i]];
                results.push(converted);
            }

            if(!results) return '';

            return results.join(' OR ');
        },

        mapNeedsToSQLConditions(key, rangeString) {
            if(!rangeString || rangeString.length==0) {
                return '';
            }

            var tmp = rangeString.split(','); // assume that the range is like this: nhà cấp 4,biệt thự,...

            var results = [];
            for(var i=0;i<tmp.length;i++) {
                results.push(`${key} = '${tmp[i]}'`);
            }

            if(!results) return '';

            return results.join(' OR ');
        },

        populateProductRuleWithClientInfo(client, is_for_rent_mode) {
            var rules = [];

            if(!client)
                return [];


            var statusCond = is_for_rent_mode?"status in ('Cho Thuê','Bán hoặc cho thuê')": "status='Đang bán'";

            // price
            // - need to translate the price range into conditions
            var tmp;
            
            if(client.c_needs_price_range && !is_for_rent_mode) {
                tmp = client.c_needs_price_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    var whereCond = this.mapPriceRangeToSQLConditions(tmp[i]);
                    rules.push({
                        id: 'price_1' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `giá mua ${tmp[i]}`,
                        valid: (client.c_needs_price_range?true:false),
                        selected: false,
                        weight: 10000
                    });
                }
            }

            if(client.needs_price_range && !is_for_rent_mode) {
                tmp = client.needs_price_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    var whereCond = this.mapPriceRangeToSQLConditions(tmp[i]);
                    rules.push({
                        id: 'price_2_' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `giá mua ${tmp[i]}`,
                        valid: (client.needs_price_range?true:false),
                        selected: false,
                        weight: 10000
                    });
                }
            }

            if(client.c_needs_price_rent_range && is_for_rent_mode) {
                tmp = client.c_needs_price_rent_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    var whereCond = this.mapPriceRentRangeToSQLConditions(tmp[i]);
                    rules.push({
                        id: 'price_rent_1_' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `giá thuê ${tmp[i]}`,
                        valid: (client.c_needs_price_rent_range?true:false),
                        selected: false,
                        weight: 10000
                    });
                }
            }
            
            if(client.needs_area_range) {
                tmp = client.needs_area_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapAreaRangeToSQLConditions(tmp[i])
                    rules.push({
                        id: 'area' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `diện tích ${tmp[i]}`,
                        valid: (client.needs_area_range?true:false),
                        selected: false,
                        weight: 1000
                    });
                }
            }

            if(client.needs_population_area) {
                tmp = client.needs_population_area.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapNeedsToSQLConditions('project', tmp[i])
                    rules.push({
                        id: 'project' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `khu dân cư ${tmp[i]}`,
                        valid: (client.needs_population_area?true:false),
                        selected: false,
                        weight: 100
                    });
                }
            }

            if(client.needs_structure) {
                tmp = client.needs_structure.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapNeedsToSQLConditions('structure', tmp[i])
                    rules.push({
                        id: 'structure' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `cấu trúc ${tmp[i]}`,
                        valid: (client.needs_structure?true:false),
                        selected: false,
                        weight: 100
                    });
                }
            }

            if(client.needs_ward) {
                tmp = client.needs_ward.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapNeedsToSQLConditions('ward', tmp[i])
                    rules.push({
                        id: 'ward' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `phường ${tmp[i]}`,
                        valid: (client.needs_ward?true:false),
                        selected: false,
                        weight: 10
                    });
                }
            }

            if(client.needs_direction) {
                tmp = client.needs_direction.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapNeedsToSQLConditions('direction', tmp[i])
                    rules.push({
                        id: 'direction' + i,
                        query: `SELECT * FROM realestate.products 
                            WHERE (${whereCond}) AND (${statusCond})
                            GROUP BY id`,
                        label: `hướng ${tmp[i]}`,
                        valid: (client.needs_direction?true:false),
                        selected: false,
                        weight: 1
                    });
                }
            }

            

            return rules;
        },

        

        populateOnlineScanRuleWithClientInfo(client, is_for_rent_mode) {
            var rules = [];

            if(!client)
                return [];
            
            if(client.c_needs_price_range && !is_for_rent_mode) {
                var tmp = client.c_needs_price_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    var whereCond = this.mapPriceRangeToSQLConditions(tmp[i]);
                    rules.push({
                        id: 'price_1',
                        query: `SELECT * FROM realestate.online_scan 
                            WHERE ${whereCond} 
                                AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
                                AND rent=1
                            GROUP BY id`,
                        label: `giá mua ${tmp[i]}`,
                        valid: (client.c_needs_price_range?true:false),
                        selected: false,
                        weight: 10000
                    });
                }
            }

            if(client.needs_price_range && !is_for_rent_mode) {
                var tmp = client.needs_price_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    var whereCond = this.mapPriceRangeToSQLConditions(tmp[i]);
                    rules.push({
                        id: 'price_2',
                        query: `SELECT * FROM realestate.online_scan 
                            WHERE ${whereCond} 
                                AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
                                AND rent=1
                            GROUP BY id`,
                        label: `giá mua ${tmp[i]}`,
                        valid: (client.needs_price_range?true:false),
                        selected: false,
                        weight: 10000
                    });
                }
            }

            // if(client.needs_price_rent_range) {
            //     tmp = client.needs_price_rent_range.split(',');
            //     for(var i=0;i<tmp.length; i++){
            //         var whereCond = this.mapPriceRangeToSQLConditions(tmp[i]);
            //         rules.push({
            //             id: 'price_rent_1_' + i,
            //             query: `SELECT * FROM realestate.online_scan 
            //                 WHERE (${whereCond}) 
            //                     AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
            //                 GROUP BY id`,
            //             label: `giá thuê ${tmp[i]}`,
            //             valid: (client.needs_price_rent_range?true:false),
            //             selected: false,
            //             weight: 10000
            //         });
            //     }
            // }

            if(client.c_needs_price_rent_range && is_for_rent_mode) {
                tmp = client.c_needs_price_rent_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    var whereCond = this.mapPriceRangeToSQLConditions(tmp[i]);
                    rules.push({
                        id: 'price_rent_2_' + i,
                        query: `SELECT * FROM realestate.online_scan 
                            WHERE (${whereCond}) 
                                AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
                                AND rent=1
                            GROUP BY id`,
                        label: `giá thuê ${tmp[i]}`,
                        valid: (client.c_needs_price_rent_range?true:false),
                        selected: false,
                        weight: 10000
                    });
                }
            }

            if(client.needs_area_range) {
                tmp = client.needs_area_range.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapAreaRangeToSQLConditions(tmp[i])
                    rules.push({
                        id: 'area',
                        query: `SELECT * FROM realestate.online_scan 
                            WHERE  ${whereCond}
                                AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
                                AND rent=1
                            GROUP BY id`,
                        label: `diện tích ${tmp[i]}`,
                        valid: (client.needs_area_range?true:false),
                        selected: false,
                        weight: 1000
                    });
                }
            }

            if(client.needs_population_area) {
                tmp = client.needs_population_area.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapNeedsToSQLConditions('project', tmp[i])
                    rules.push({
                        id: 'project' + i,
                        query: `SELECT * FROM realestate.online_scan 
                            WHERE  ${whereCond}
                                AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
                                AND rent=1
                            GROUP BY id`,
                        label: `khu dân cư ${tmp[i]}`,
                        valid: (client.needs_population_area?true:false),
                        selected: false,
                        weight: 100
                    });
                }
            }

            if(client.needs_ward) {
                tmp = client.needs_ward.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapNeedsToSQLConditions('ward', tmp[i])
                    rules.push({
                        id: 'ward' + i,
                        query: `SELECT * FROM realestate.online_scan 
                            WHERE  ${whereCond}
                                AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
                                AND rent=1
                            GROUP BY id`,
                        label: `phường ${tmp[i]}`,
                        valid: (client.needs_ward?true:false),
                        selected: false,
                        weight: 10
                    });
                }
            }

            if(client.needs_structure) {
                tmp = client.needs_structure.split(',');
                for(var i=0;i<tmp.length; i++){
                    whereCond = this.mapNeedsToSQLConditions('structure', tmp[i])
                    rules.push({
                        id: 'structure' + i,
                        query: `SELECT * FROM realestate.online_scan 
                            WHERE  ${whereCond}
                                AND date >= DATE_SUB(NOW(),INTERVAL 1 YEAR)
                                AND rent=1
                            GROUP BY id`,
                        label: `cấu trúc ${tmp[i]}`,
                        valid: (client.needs_structure?true:false),
                        selected: false,
                        weight: 1
                    });
                }
            }

            return rules;
        },

        async loadClientInfo() {
            this.isLoadingClientInfo = true;
            try {
                var clientService = new ClientService();
                // load the data from a view which aggregated all user needs into one row
                this.clientInfo = await clientService.getDetailFromView(this.clientId, 'clients_list_filter_2');

                console.log('client info: ', this.clientInfo);
                this.productRules = this.populateProductRuleWithClientInfo(this.clientInfo, false);
                this.productRentRules = this.populateProductRuleWithClientInfo(this.clientInfo, true);

                this.onlineRules = this.populateOnlineScanRuleWithClientInfo(this.clientInfo, false);
                this.onlineRentRules = this.populateOnlineScanRuleWithClientInfo(this.clientInfo, true);

                this.selectedMode = 'product'; // set default value
                this.rules = this.productRules;
            }
            catch(e) {

            }
            finally{
                this.isLoadingClientInfo = false;
            }
            
            
        },

      
        updateProductListMatchingRules(products, rule) {
            rule.products = products;

            for(var i=0; i<products.length; i++) {
                var p = products[i];

                if(!this.productMap[p.id]) {
                    this.productMap[p.id] = p;
                }

                if(this.productMap[p.id]) {
 
                    if(!this.productMap[p.id].matching) {
                        this.productMap[p.id].matching = [];
                        this.productMap[p.id].matchingLabel = [];
                        this.productMap[p.id].matchingWeight = 0;
                    }

                    this.productMap[p.id].matching.push(rule);
                    this.productMap[p.id].matchingLabel.push(rule.label);
                    this.productMap[p.id].matchingWeight += rule.weight;
                }
            }

            console.log(this.productMap);
        },

      async suggestByRule(rule) {
          console.log('suggest by rule ', rule);
          var query = rule.query;
          query = encodeURI(query);

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;

        try {
            var response = await axios.get(url);

            console.log('suggest by rule > result ', response.data);
            this.updateProductListMatchingRules(response.data, rule);
        } 
        catch(err) {
            alert('Có lỗi khi tải dữ liệu.');
            console.log(err);
        }
      },

      async suggestByAllRules() {
          this.isLoadingList = true;
          this.message = 'Bắt đầu tìm kiếm...<br/>';
          // load full client list

          this.productMap = {};

        //   await this.loadClientList();
        //   this.message += 'Tải thông tin khách hàng.<br/>';
        //   await this.loadClientInfo();

          // load each rule, each rule should produce one client list
          for(var i=0; i<this.rules.length; i++) {
            
            if(this.rules[i].valid && this.rules[i].selected)
            {
                this.message += 'Đang tìm kiếm theo ' + this.rules[i].label; 
                await this.suggestByRule(this.rules[i]);
                this.message += ` -> kết thúc, tìm thấy ${this.rules[i].products.length} sản phẩm phù hợp.`;
            }
            else if(!this.rules[i].valid) {
                this.message += 'Đang tìm kiếm theo ' + this.rules[i].label; 
                this.message += ' -> bỏ qua do khách hàng không có thông tin này.'
            } else {
                continue;
                // this.message += ' -> bỏ qua.';
            }


            this.message += '<br/>';

          }

            this.message += 'Tổng hợp kết quả...<br/>'
            var tmp = [];
            for(var key in this.productMap) {
                tmp.push(this.productMap[key]);
            }

            // this.productList = tmp;

            this.message += 'Sắp xếp kết quả theo thứ tự ưu tiên...<br/>'

            // sort the product list
            tmp = tmp.sort(function(productA, productB) {
                var matchingWeight = 0;

                // console.log('sort ' + productA.matchingWeight + ' ' + productB.matchingWeight + ' -> ' + (productA.matchingWeight - productB.matchingWeight));
                // if(productA.matching.lenght > productB.matching.lenght) {
                //     // console.log('-> ', clientA.matching.lenght - clientB.matching.lenght)
                //     return -1*(productA.matching.lenght - productB.matching.lenght)
                // }
                // else if(productA.matching.lenght < productB.matching.lenght) {
                //     // console.log('-> ', clientA.matching.lenght - clientB.matching.lenght)
                //     return -1*(productA.matching.lenght - productB.matching.lenght)
                // }
                // else {
                    // compare by weight
                    // console.log('-> weightDiff: ', productA.matchingWeight - productB.matchingWeight)
                    matchingWeight = -1*(productA.matchingWeight - productB.matchingWeight)
                // }

                matchingWeight = -1*(productA.matchingWeight - productB.matchingWeight)
                // if matching weight is the same, compare by date
                if(matchingWeight == 0) {
                    matchingWeight = productA.date > productB.date ? -1 : 1;
                }

                return matchingWeight;
            });

            this.productList = tmp;
            this.tableFormat.totalRow = this.productList.length;

          this.message += 'Đã hoàn tất.<br/>'

          this.isLoadingList = false;
      },

  },
  props: ['clientId'],
  mounted () {
    this.loadClientInfo();
  }
}
</script>

<style scoped>
</style>
